import type { ColumnDef } from "@tanstack/react-table";
import { buildTagColumn } from "@/components/Table";
import type { TagType } from "@/components/Tag/Tag";
import { renderEmptyCellState } from "@/components/Table/utils";
import { toFormat } from "@/lib/dateHelpers";
import { formatEnumLabel } from "@/pages/billing/finance/commission/_utils";
import type { PersonGrpFaaRow } from "../types";

function consentStatusType(status: PersonGrpFaaRow["status"]): TagType {
  if (status === "ACTIVE") return "success";
  if (status === "ENDED") return "surface";
  return "warn";
}

export function getFaaColumns(): ColumnDef<PersonGrpFaaRow, unknown>[] {
  return [
    {
      id: "campaign",
      accessorFn: (row) => row.campaignLabel,
      header: "Campaign",
      size: 180,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(row.original.campaignLabel)
    },
    {
      id: "partner",
      accessorFn: (row) => row.partnerName,
      header: "Partner",
      size: 180,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(row.original.partnerName)
    },
    buildTagColumn<PersonGrpFaaRow>({
      accessorKey: "status",
      header: "Status",
      size: 120,
      getTagLabel: (row) => formatEnumLabel(row.status),
      getTagType: (row) => consentStatusType(row.status),
      getTagStyle: () => "strong"
    }),
    {
      accessorKey: "attributionModel",
      header: "Attribution",
      size: 140,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(formatEnumLabel(row.original.attributionModel))
    },
    {
      accessorKey: "ownership",
      header: "Ownership",
      size: 120,
      enableSorting: false,
      cell: ({ row }) =>
        renderEmptyCellState(row.original.ownership ? formatEnumLabel(row.original.ownership) : undefined)
    },
    {
      accessorKey: "startsAt",
      header: "Starts",
      size: 120,
      cell: ({ row }) => renderEmptyCellState(toFormat(row.original.startsAt))
    },
    {
      accessorKey: "endsAt",
      header: "Ends",
      size: 120,
      cell: ({ row }) => renderEmptyCellState(row.original.endsAt ? toFormat(row.original.endsAt) : undefined)
    }
  ];
}
